export const businessNeeds: string[] = [
  'Create qualified demand',
  'Turn interest into leads',
  'Sell and collect payment',
  'Keep customers informed',
  'Connect internal systems',
]

/** Compact journey used in place of the need cards on small screens. */
export const journeySteps: string[] = ['Attract', 'Convert', 'Sell', 'Serve', 'Improve']

export type SystemModule = {
  label: string
  note: string
  accent: 'orange' | 'cyan' | 'green'
}

export const systemModules: SystemModule[] = [
  { label: 'Website and content', note: 'The customer-facing experience', accent: 'cyan' },
  { label: 'Search and paid demand', note: 'Visibility in the right markets', accent: 'cyan' },
  { label: 'Lead flow and communication', note: 'Calls, forms, quotes, booking, text, and chat', accent: 'orange' },
  { label: 'Ecommerce and payments', note: 'Products, pricing, checkout, and customer accounts', accent: 'green' },
  { label: 'Integrations and automation', note: 'Business systems and workflows connected', accent: 'cyan' },
  { label: 'Hosting, reporting, and support', note: 'Managed after launch', accent: 'orange' },
]

/** Condensed grouping used on small screens so the panel stays short. */
export const mobileModules: SystemModule[] = [
  { label: 'Customer experience and demand', note: 'Site, content, search, and paid visibility', accent: 'cyan' },
  { label: 'Leads, ecommerce, and payments', note: 'Calls, forms, quotes, checkout, and accounts', accent: 'orange' },
  { label: 'Integrations, hosting, and ongoing management', note: 'Systems connected and managed after launch', accent: 'green' },
]
